/* UMI&UMI — restyle the Shopify Inbox chat launcher to match the brand's warm gold palette.
   The Inbox launcher lives in an open shadow DOM. Injecting a <style> into that root does NOT
   reliably beat Inbox's own stylesheet, so we set inline styles directly on the button element
   (inline !important always wins) and keep them applied via a MutationObserver in case Inbox
   re-renders the button. Only the launcher is touched — the conversation window is left alone. */
(function () {
  var GOLD = '#c6a568';        // champagne gold (matches the gold-jewelry / cream theme)
  var GOLD_HOVER = '#b8965a';
  var INK = '#2b2b2b';         // dark label + icon, legible on gold, matches theme text

  function paintToggle(sr) {
    var toggle = sr.querySelector('.chat-toggle');
    if (!toggle) return false;
    toggle.style.setProperty('background', GOLD, 'important');
    toggle.style.setProperty('background-color', GOLD, 'important');
    toggle.style.setProperty('color', INK, 'important');
    toggle.style.setProperty('box-shadow', '0 6px 20px rgba(120,95,45,.28)', 'important');
    // recolor the "Chat" label + bubble icon
    var kids = toggle.querySelectorAll('*');
    for (var i = 0; i < kids.length; i++) {
      var e = kids[i], t = e.tagName.toLowerCase();
      e.style.setProperty('color', INK, 'important');
      if (t === 'svg' || t === 'path' || t === 'g') {
        e.style.setProperty('fill', INK, 'important');
        e.style.setProperty('stroke', INK, 'important');
      }
    }
    // hover accent (inline base blocks the stylesheet :hover, so do it with listeners)
    if (!toggle.__umiHover) {
      toggle.__umiHover = true;
      toggle.addEventListener('mouseenter', function () {
        toggle.style.setProperty('background', GOLD_HOVER, 'important');
        toggle.style.setProperty('transform', 'translateY(-1px)', 'important');
      });
      toggle.addEventListener('mouseleave', function () {
        toggle.style.setProperty('background', GOLD, 'important');
        toggle.style.setProperty('transform', 'none', 'important');
      });
    }
    return true;
  }

  function tryStyle() {
    var host = document.querySelector('#ShopifyChat, inbox-online-store-chat');
    if (!host || !host.shadowRoot) return false;
    var sr = host.shadowRoot;
    var ok = paintToggle(sr);
    if (ok && !sr.__umiObserved) {
      sr.__umiObserved = true;
      try {
        new MutationObserver(function () { paintToggle(sr); })
          .observe(sr, { childList: true, subtree: true });
      } catch (e) {}
    }
    return ok;
  }

  var tries = 0;
  var iv = setInterval(function () {
    tries++;
    if (tryStyle() || tries > 60) clearInterval(iv);
  }, 500);
})();
